import { compose } from 'recompose';

import withCallTrackingUrl from '../../../../Hocs/withCallTrackingUrl';
import withModal from '../../../../Hocs/withModal';
import Layout from './Layout.view';

export default compose(withCallTrackingUrl(), withModal)(Layout);
